export const CALLING_TASK_RESULTS = [
  'answered',
  'not_answered',
  'left_voicemail',
  'do_not_contact',
  'call_in_progress',
  'incorrect_number',
];

export const VISITING_TASK_RESULTS = [
  'home',
  'not_home',
  'new_occupants',
  'property_not_accessible',
  'vacant_house_or_lot',
];
